module.exports = __webpack_public_path__ + "img/11.c767a436.png";